/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var HouzzIcon = createIcon({
  name: 'HouzzIcon',
  height: 512,
  width: 448,
  svgPath: 'M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default HouzzIcon;